import {brandsBase} from '@root/brands/brandsBase';

export const brand = brandsBase.chatCoffee;
